export function setLeadingCapital(inputString: string) {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1)
}
